import { render, staticRenderFns } from "./BMICalculator.vue?vue&type=template&id=090cb5e7&scoped=true"
import script from "./BMICalculator.vue?vue&type=script&lang=js"
export * from "./BMICalculator.vue?vue&type=script&lang=js"
import style0 from "./BMICalculator.vue?vue&type=style&index=0&id=090cb5e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090cb5e7",
  null
  
)

export default component.exports